import { render, staticRenderFns } from "./forgotPassWord.vue?vue&type=template&id=a28a4fa6&"
import script from "./forgotPassWord.vue?vue&type=script&lang=js&"
export * from "./forgotPassWord.vue?vue&type=script&lang=js&"
import style0 from "./forgotPassWord.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports